"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOOGLE_PLAY_LINK = exports.APP_STORE_LINK = exports.GOOGLE_PAY_TEST_ENV = exports.APPLE_MERCHANT_ID = exports.STRIPE_PUBLISHABLE_KEY = exports.APP_URL = exports.USE_SIGNATURE = exports.API_URL = void 0;
exports.API_URL = 'https://api.flyway.me/';
exports.USE_SIGNATURE = true;
exports.APP_URL = 'https://flyway.me/';
exports.STRIPE_PUBLISHABLE_KEY = '';
exports.APPLE_MERCHANT_ID = '';
exports.GOOGLE_PAY_TEST_ENV = true;
exports.APP_STORE_LINK = "https://apps.apple.com/pl/app/flyway/id6475721821";
exports.GOOGLE_PLAY_LINK = "https://play.google.com/store/apps/details?id=com.qvistorp.flywayapp";
